module.exports = __webpack_public_path__ + "img/7.7424c4d2.png";